module.exports = __webpack_public_path__ + "img/Hero.217f200d.png";